import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '@com/utils/storage'
import JSONParse from '@/utils/JSONParse'
import { WorkSpaceSetting } from '@/types/dmaker/workspace'
import Cookies from 'js-cookie'

// 简化后的高阶函数，专门用于 0|1 类型的存储
export const createBinaryStorageHelper = (key: string) => ({
  set(val: 1 | 0): void {
    setLocalStorage(key, String(val))
  },
  get(): 1 | 0 {
    return Number(getLocalStorage(key)) as 1 | 0
  },
  remove(): void {
    removeLocalStorage(key)
  },
})

const privacyKey = 'is_agree_privacy_agreement'
export const privacyAgreement = createBinaryStorageHelper(privacyKey)

const workspaceSettingKey = 'workspace_setting'
export const workspaceSetting = {
  set(value: WorkSpaceSetting): void {
    setLocalStorage(workspaceSettingKey, JSON.stringify(value))
  },
  get(): WorkSpaceSetting {
    return JSONParse(getLocalStorage(workspaceSettingKey))
  },
  remove(): void {
    removeLocalStorage(workspaceSettingKey)
  },
}

const tokenKey = 'token'
const cookieTokenKey = 'mws_auth'
export const token = {
  set(val: string): void {
    // 保存30天，与后端一致
    Cookies.set(cookieTokenKey, val, { expires: 30, path: '/' })
    setLocalStorage(tokenKey, val)
  },
  get(): string {
    if ((getLocalStorage(tokenKey) as string) && Cookies.get(cookieTokenKey)) {
      return getLocalStorage(tokenKey) as string
    }
    return ''
  },
  remove(): void {
    Cookies.remove(cookieTokenKey)
    removeLocalStorage(tokenKey)
  },
  getOnlyCookie(): string | undefined {
    return Cookies.get(cookieTokenKey) ?? undefined
  },
}

const notesKey = 'ps_notes'
export const psNotes = createBinaryStorageHelper(notesKey)
